import { sortBy } from "lodash-es";
import {BookingMetaByEquipment} from "../../../constants";

const metaFieldsKeys = Object.keys(BookingMetaByEquipment.fields)
const BOOKING_CORE = metaFieldsKeys.filter( key => BookingMetaByEquipment.fields[key].lockVisible)

export const onAgGridColumnApply = ({ gridRef, savedShowcolumns }) => {
  if (!gridRef?.current?.columnApi || !savedShowcolumns) return;


  let columnState = gridRef.current.columnApi.getColumnState();
  const showColumns = sortBy(savedShowcolumns, ["order"], ["asc"]);

  const visibleIds = new Set([
    ...BOOKING_CORE,
    ...showColumns.map(c => c.key),
    'actions',
  ]);

  showColumns.forEach((column, orderIndex) => {
    const index = columnState.findIndex((c) => c.colId === column.key);
    if (index === -1) return;
    const [splicedObj] = columnState.splice(index, 1);
    splicedObj.hide = splicedObj.colId === "equipment_model";
    columnState.splice(orderIndex + BOOKING_CORE.length, 0, splicedObj);
  });

  columnState = columnState.map((column, index) => {
    const isCore = BOOKING_CORE.includes(column.colId);
    if (!isCore && index >= BOOKING_CORE.length + showColumns.length && column.colId !== "actions") {
      column.hide = true;
    }
    return column;
  });

  columnState = columnState.map(col => ({
    ...col,
    hide: !visibleIds.has(col.colId) || col.hide,
  }));

  const coreStates = [];
  BOOKING_CORE.forEach((id) => {
    const idx = columnState.findIndex((c) => c.colId === id);
    if (idx > -1) coreStates.push(...columnState.splice(idx, 1));
  });
  columnState = [...coreStates, ...columnState];

  gridRef.current.columnApi.applyColumnState({
    state: columnState,
    applyOrder: true,
  });
};
